module.exports = __webpack_public_path__ + "static/media/Broodmother.176b25d2.png";